/** Shell 癰귣챶揆 ??tier ??pathname prefix 筌띲끉臾?*/

export const SHELL_LAYOUT_TIERS = {
  DEFAULT: 'default',
  WIDE: 'wide',
  FULL: 'full',
}

const FULL_PATH_PREFIXES = [
  '/sales/public-card',
  '/sales/public-landing',
  '/sales/org-homepage',
]

/** ???뵠?됰텑?캲M ??揶쎛嚥??⑤벀而???袁⑹뒄???遺얇늺 */
const WIDE_PATH_PREFIXES = [
  '/',
  '/menu-overview',
  '/users',
  '/counterparts',
  '/support/customers',
  '/support/maturity-ledger',
  '/support/customer-tools',
  '/support/claims',
  '/health-analysis',
  '/hidden-insurance-money',
  '/health/disease-stats',
  '/fire/building-registry',
  '/work/calendar',
  '/work/insurance-market-insights',
  '/work/policy-lookup',
  '/work/personal-tasks',
  '/work/insurer-newsletters',
  '/work/insurer-systems',
  '/design',
  '/data/insurers',
  '/data/terms',
  '/files',
  '/requests',
  '/work/education',
  '/support/inquiries',
  '/withdrawal-approvals',
  '/ops',
  '/subscriptions',
  '/org-dashboard',
  '/org-library',
]

export function resolveShellLayoutTier(pathname) {
  const path = pathname || '/'
  if (FULL_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return SHELL_LAYOUT_TIERS.FULL
  }
  if (WIDE_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return SHELL_LAYOUT_TIERS.WIDE
  }
  return SHELL_LAYOUT_TIERS.DEFAULT
}

export function shellMainContentClass(tier) {
  switch (tier) {
    case SHELL_LAYOUT_TIERS.WIDE:
    case SHELL_LAYOUT_TIERS.FULL:
      return 'w-full max-w-none'
    default:
      return 'mx-auto w-full max-w-6xl'
  }
}
